/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NovitusEDocumentDto } from './NovitusEDocumentDto';
import {
    NovitusEDocumentDtoFromJSON,
    NovitusEDocumentDtoFromJSONTyped,
    NovitusEDocumentDtoToJSON,
} from './NovitusEDocumentDto';

/**
 * 
 * @export
 * @interface NovitusBuyerDto
 */
export interface NovitusBuyerDto {
    /**
     * Nazwa kupującego (1-256 znaków)
     * @type {string}
     * @memberof NovitusBuyerDto
     */
    name?: string;
    /**
     * Typ numeru identyfikacyjnego nabywcy: 'nip', 'regon', lub 'pesel'
     * @type {string}
     * @memberof NovitusBuyerDto
     */
    id_type?: string;
    /**
     * Numer identyfikacyjny nabywcy (1-16 znaków)
     * @type {string}
     * @memberof NovitusBuyerDto
     */
    id?: string;
    /**
     * Wybór etykiety: 'nabywca' lub 'odbiorca'
     * @type {string}
     * @memberof NovitusBuyerDto
     */
    label_type?: string;
    /**
     * Adres nabywcy
     * @type {Array<string>}
     * @memberof NovitusBuyerDto
     */
    address?: Array<string>;
    /**
     * Opcjonalna konfiguracja eDokumentu
     * @type {NovitusEDocumentDto}
     * @memberof NovitusBuyerDto
     */
    e_document?: NovitusEDocumentDto;
}

/**
 * Check if a given object implements the NovitusBuyerDto interface.
 */
export function instanceOfNovitusBuyerDto(value: object): value is NovitusBuyerDto {
    return true;
}

export function NovitusBuyerDtoFromJSON(json: any): NovitusBuyerDto {
    return NovitusBuyerDtoFromJSONTyped(json, false);
}

export function NovitusBuyerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusBuyerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'id_type': json['id_type'] == null ? undefined : json['id_type'],
        'id': json['id'] == null ? undefined : json['id'],
        'label_type': json['label_type'] == null ? undefined : json['label_type'],
        'address': json['address'] == null ? undefined : json['address'],
        'e_document': json['e_document'] == null ? undefined : NovitusEDocumentDtoFromJSON(json['e_document']),
    };
}

export function NovitusBuyerDtoToJSON(value?: NovitusBuyerDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'id_type': value['id_type'],
        'id': value['id'],
        'label_type': value['label_type'],
        'address': value['address'],
        'e_document': NovitusEDocumentDtoToJSON(value['e_document']),
    };
}

